const ScriptsQuestionTypeToolTips = {
    Eng: {
        TrueFalse: 'Choose an option above',
        Text: 'Type your response...',
        Date: 'Select date',
        Time: 'Select time',
        DateTime: 'Select date and time',
        AllThatApply: 'Choose option(s) above',
        MC: 'Choose an option above',
        FTEllipses: '...', // used to show a block input field
        FTPhone: 'Enter your phone number...', // CHAT-7004
        FTMessage: 'Type your message...',
        FTName: 'Enter your name...', // CHAT-7003
        FTEmail: 'Enter your email address...', /// /CHAT-7005
        FTZipcode: 'Enter your zip code...',
        AppointmentSchedule: 'Please select a date and time',
        FTAddress: 'Enter your address...',
        Hello: 'Hello',
    },
    Spa: {
        TrueFalse: 'Elige una opción arriba',
        Text: 'Escriba su respuesta...',
        Date: 'Seleccione fecha',
        Time: 'Seleccionar hora',
        DateTime: 'Seleccionar fecha y hora',
        AllThatApply: 'Elija la(s) opción(es) arriba',
        MC: 'Elige una opción arriba',
        FTEllipses: '...',
        FTPhone: 'Ingrese su número telefónico...',
        FTMessage: 'Escribe tu mensaje...',
        FTName: 'Introduzca su nombre...',
        FTEmail: 'Ingrese su dirección de correo electrónico...',
        FTZipcode: 'Ingrese su codigo postal...',
        AppointmentSchedule: 'Por favor seleccione una fecha y hora',
        FTAddress: 'Introduce tu dirección...',
        Hello: 'Hola',
    }
};
export default ScriptsQuestionTypeToolTips;
